import { useState, useEffect } from "react";
import { CalendarOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Fragment } from "react";
import { Button, Checkbox, Col, Form, Row, Select } from "antd";
import { INPUT_SIZE } from "../../common/ThemeConstants";
import BasicFormComponent from "../../components/formComponent/BasicFormComponent";
import FormTextField from "../../components/general/FormTextField";
import FormCheckbox from "../../components/general/FormCheckbox";
import {
  resetState,
  setSearchFieldValue,
  setInitialState,
} from "../../redux/actions/basicFormAction";

const { Option } = Select;

const initialSearchValues = {
  OperationId: null,
  CompanyId: null,
  DiscountId: null,
  DiscountPercent: null,
  DiscountTimeStart: "",
  DiscountTimeEnd: "",
  DiscountName: "",
  StartDate: "",
  EndDate: "",
  DiscountTypeId: null,
  AreaId: "",
  BranchId: "",
  OrderMode: "",
  OrderType: "",
  ProductDetail: "",
  IsActiveInWeb: false,
  IsActiveInPOS: false,
  IsActiveInODMS: false,
  IsActiveInMobile: false,
  UserIP: "",
  UserId: null,
  DiscountAvailability: [],
  IsPercentage: null,
  IsAutoDiscount: null,
  DiscountCapStart: 0,
  DiscountCapEnd: 0,
  IsVoucher: false,
  FirstTimeUserOnly: false,
  DeliveryChargesWaiveOff: false,
  MaxCount: 0,
  MaxCountPerUser: 0,
  MinOrderAmount: 0,
  ApplyWithOtherDiscounts: false,
  VoucherCode: "",
};

const initialFormValues = {
  OperationId: null,
  CompanyId: null,
  DiscountId: null,
  DiscountPercent: null,
  DiscountTimeStart: "",
  DiscountTimeEnd: "",
  DiscountName: "",
  StartDate: "",
  EndDate: "",
  DiscountTypeId: null,
  AreaId: "",
  BranchId: "",
  OrderMode: "",
  OrderType: "",
  ProductDetail: "",
  IsActiveInWeb: false,
  IsActiveInPOS: false,
  IsActiveInODMS: false,
  IsActiveInMobile: false,
  UserIP: "",
  UserId: null,
  DiscountAvailability: [],
  IsPercentage: null,
  IsAutoDiscount: null,
  DiscountCapStart: 0,
  DiscountCapEnd: 0,
  IsVoucher: false,
  FirstTimeUserOnly: false,
  DeliveryChargesWaiveOff: false,
  MaxCount: 0,
  MaxCountPerUser: 0,
  MinOrderAmount: 0,
  ApplyWithOtherDiscounts: false,
  VoucherCode: "",
};

const voucherColumns = [
  {
    title: "Name",
    dataIndex: "Name",
    key: "Name",
  },
  {
    title: "Source",
    dataIndex: "Source",
    key: "Source",
  },
  {
    title: "APP/WEB/BOTH",
    dataIndex: "APP/WEB/BOTH",
    key: "APP/WEB/BOTH",
  },
  {
    title: "Used Count",
    dataIndex: "UsedCount",
    key: "UsedCount",
  },
  {
    title: "Max Count",
    dataIndex: "MaxCount",
    key: "MaxCount",
  },
  {
    title: "Start Time",
    dataIndex: "StartTime",
    key: "StartTime",
  },
  {
    title: "End Time",
    dataIndex: "EndTime",
    key: "End Time",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
];

export default function PromoCodeForm() {
  const dispatch = useDispatch();
  const controller = new window.AbortController();
  const userData = useSelector((state) => state.authReducer);
  const {
    formFields,
    searchFields,
    itemList,
    formLoading,
    tableLoading,
    supportingTable,
  } = useSelector((state) => state.basicFormReducer);
  const [formValues, setFormValues] = useState(initialFormValues);
  const handleFormChange = (data) => {
    setFormValues({ ...formValues, [data.name]: data.value });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    searchFields.PromoCode = searchFields.PromoCode.trim();
    dispatch(
      setInitialState(
        "/CrudDiscountVoucher",
        searchFields,
        initialFormValues,
        searchFields,
        controller,
        userData
      )
    );
  };
  const handleSearchChange = (data) => {
    dispatch(setSearchFieldValue(data));
  };

  const handleSubmit = (values) => {
    console.log("Form values:", values);
  };

  const handleCheckBox = (item, data) => {
    if (data.name === "OrderMode") {
      if (data.value === true) {
        const itemId = item.SetupDetailId;
        setOrderModeIds([...orderModeIds, itemId]);
      } else {
        const orderModeArr = orderModeIds;
        let index = orderModeArr.findIndex((x) => x === item.SetupDetailId);
        if (index > -1) {
          orderModeArr.splice(index, 1);
        }
        setOrderModeIds([...orderModeArr]);
      }
    } else if (data.name === "OrderSource") {
      if (data.value === true) {
        const itemId = item.SetupDetailId;
        setSourceIds([...orderSourceIds, itemId]);
      } else {
        const orderSourceArr = orderSourceIds;
        let index = orderSourceArr.findIndex((x) => x === item.SetupDetailId);
        if (index > -1) {
          orderSourceArr.splice(index, 1);
        }
        setSourceIds([...orderSourceArr]);
      }
    } else if (data.name === "BranchId") {
      if (data.value === true) {
        const itemId = item.BranchId;
        setBranchIds([...BranchIds, itemId]);
      } else {
        const branchIdsArr = BranchIds;
        let index = branchIdsArr.findIndex((x) => x === item.BranchId);
        if (index > -1) {
          branchIdsArr.splice(index, 1);
        }
        setBranchIds([...branchIdsArr]);
      }
    } else if (data.name === "ProductDetail") {
      if (data.value === true) {
        const itemId = item.ProductDetailId;
        setProductDetailIds([...ProductDetailIds, itemId]);
      } else {
        const productDetailIdsArr = ProductDetailIds;
        let index = productDetailIdsArr.findIndex(
          (x) => x === item.ProductDetailId
        );
        if (index > -1) {
          productDetailIdsArr.splice(index, 1);
        }
        setProductDetailIds([...productDetailIdsArr]);
      }
    } else if (data.name === "AreaId") {
      if (data.value === true) {
        const itemId = item.AreaId;
        setAreaIds([...AreaIds, itemId]);
      } else {
        const areaIdsArr = AreaIds;
        let index = areaIdsArr.findIndex((x) => x === item.AreaId);
        if (index > -1) {
          areaIdsArr.splice(index, 1);
        }
        setAreaIds([...areaIdsArr]);
      }
    }
    setFormValues({ ...formValues, [data.name]: data.value });
  };

  useEffect(() => {
    dispatch(
      setInitialState(
        "/CrudPromotionVoucher",
        initialSearchValues,
        initialFormValues,
        initialSearchValues,
        controller,
        userData
      )
    );

    return () => {
      controller.abort();
      dispatch(resetState());
    };
  }, []);

  const formPanel = (
    <Fragment>
      <Row gutter={[8, 8]} style={{ marginBottom: 20, alignItems: "flex-end" }}>
        <Col span={8}>
          <FormTextField
            label="Voucher Code"
            name="VoucherCode"
            size={INPUT_SIZE}
            value={formValues.VoucherCode}
            onChange={handleFormChange}
            required={true}
          />
        </Col>
        <Col span={8}>
          <FormTextField
            type="date"
            label="Start Date"
            style={{ width: "100%" }}
            defaultValue={formValues.StartDate}
            name="StartDate"
            value={formValues.StartDate}
            onChange={(e) => {
              setFormValues({
                ...formValues,
                StartDate: e.value,
              });
            }}
          />
        </Col>
        <Col span={8}>
        <FormTextField
            type="date"
            label="End Date"
            style={{ width: "100%" }}
            defaultValue={formValues.EndDate}
            name="EndDate"
            value={formValues.EndDateDate}
            onChange={(e) => {
              setFormValues({
                ...formValues,
                EndDate: e.value,
              });
            }}
          />
        </Col>
        {/* todo here */}
        {/* <Col span={8}>
          <label>Discount End Date</label>
          <FormTextField
            type="date"
            style={{ width: "100%" }}
            defaultValue={formValues.EndDate}
            name="EndDate"
            value={formValues.EndDate ? formValues.EndDate : formValues.EndDate}
            onChange={(e) => {
              setFormValues({
                ...formValues,
                EndDate: e.value,
              });
            }}
          />
        </Col> */}
        <Col span={8}>
          <label>Discount Start Time</label>
          <FormTextField
            type="time"
            style={{ width: "100%" }}
            placeholder="Discount Start Time"
            value={
              formValues.DiscountTimeStart ? formValues.DiscountTimeStart : ""
            }
            onChange={(e) => {
              setFormValues({
                ...formValues,
                DiscountTimeStart: e.value,
              });
            }}
          />
        </Col>

        <Col span={8}>
          <label>Discount End Time</label>
          <FormTextField
            type="time"
            style={{ width: "100%" }}
            placeholder="Discount End Time"
            //  format="hh:mm:ss"
            value={formValues.DiscountTimeEnd ? formValues.DiscountTimeEnd : ""}
            onChange={(e) => {
              setFormValues({
                ...formValues,
                DiscountTimeEnd: e.value,
              });
            }}
          />
        </Col>
        
        <Col span={8} >
          <FormCheckbox
            name="FirstTimeUserOnly"
            checked={formValues.FirstTimeUserOnly}
            label="For First Time User Only"
            onChange={(event) => {
              handleCheckBox({}, event);
            }}
          />
        </Col>
        <Col span={4}>
          <FormCheckbox
            name="IsActiveInWeb"
            checked={formValues.IsActiveInWeb}
            label="Active in Web"
            onChange={(event) => {
              handleCheckBox({}, event);
            }}
          />
        </Col>
        <Col span={4}>
          <FormCheckbox
            name="IsActiveInPOS"
            checked={formValues.IsActiveInPOS}
            label="Active in POS"
            onChange={(event) => {
              handleCheckBox({}, event);
            }}
          />
        </Col>
        <Col span={4}>
          <FormCheckbox
            name="IsActiveInMobile"
            checked={formValues.IsActiveInMobile}
            label="Active in Mob"
            onChange={(event) => {
              handleCheckBox({}, event);
            }}
          />
        </Col>
        <Col span={4}>
          <FormCheckbox
            name="IsActiveInODMS"
            checked={formValues.IsActiveInODMS}
            label="Active in ODMS"
            onChange={(event) => {
              handleCheckBox({}, event);
            }}
          />
        </Col>
        <Col span={4}>
          <FormCheckbox
            name="IsPercentage"
            checked={formValues.IsPercentage}
            label="Is Percentage"
            onChange={(event) => {
              handleCheckBox({}, event);
            }}
          />
        </Col>
        <Col span={4}>
          <FormCheckbox
            name="IsAutoDiscount"
            checked={formValues.IsAutoDiscount}
            label="Is Auto Discount"
            onChange={(event) => {
              handleCheckBox({}, event);
            }}
          />
        </Col>
        {/* <Col span={4}>
            <FormCheckbox label="Open Discount" />
          </Col> */}
        <Col span={4}>
          <FormTextField
            label="Discount Cap Start"
            name="DiscountCapStart"
            size={INPUT_SIZE}
            value={formValues.DiscountCapStart}
            onChange={handleFormChange}
            isNumber="true"
          />
        </Col>
        <Col span={4}>
          <FormTextField
            label="Discount Cap End"
            name="DiscountCapEnd"
            size={INPUT_SIZE}
            value={formValues.DiscountCapEnd}
            onChange={handleFormChange}
            isNumber="true"
          />
        </Col>
      </Row>
    </Fragment>
  );

  const searchPanel = (
    <Fragment>
      <FormTextField
        colSpan={4}
        label="Promo code"
        name="PromoCode"
        value={searchFields.PromoCode}
        onChange={handleSearchChange}
      />
    </Fragment>
  );

  return (
    <BasicFormComponent
      formTitle="Promo Code"
      formPanel={formPanel}
      searchPanel={searchPanel}
      handleSearchSubmit={handleSearchSubmit}
      tableColumn={voucherColumns}
      onFormSave={handleSubmit}
    />
  );
}
